import React, { useState } from 'react'
import {
    Container,
    Text,
    Time,
    ContainerPopOver,
    ToolBoxArea,
    IntentPopOver
} from './Styled'
import { Speech } from '../../../../../../model/transcription/types'
import { toHour } from '../../../../../../helpers/dateFormatHelper'
import ReactJson from 'react-json-view'
import { Popover, Button, Space } from 'antd'
import { DatabaseOutlined, CaretRightOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../../model/rootReducer'
import IntentSelector from '../../../intentSelector/IntentSelector'

type MessageProps = {
    message: Speech
    onPlayMessage: (id: string) => void
}

const Message: React.FunctionComponent<MessageProps> = ({
    message,
    onPlayMessage
}) => {
    const [
        isExpressionPopOverVisible,
        setIsExpressionPopOverVisible
    ] = useState(false)
    const intents = useSelector((state: RootState) => state.intent.intents)

    const renderContent = () => (
        <Container isBot={message.isBot}>
            <Time>
                <p className={message.isBot ? 'right' : ''}>
                    {toHour(message.date)}
                </p>
            </Time>
            {message.technicalData != null ? (
                <Popover
                    placement="left"
                    content={
                        <ContainerPopOver>
                            <ReactJson src={message.technicalData} />
                        </ContainerPopOver>
                    }
                >
                    <Text className={message.isBot ? 'sent' : 'received'}>
                        {message.text}
                    </Text>
                </Popover>
            ) : (
                <Text className={message.isBot ? 'sent' : 'received'}>
                    {message.text}
                </Text>
            )}
            {!message.isBot ? (
                <ToolBoxArea>
                    <Space direction="horizontal">
                        {message.start !== null && (
                            <Button
                                icon={<CaretRightOutlined />}
                                value="small"
                                shape="circle"
                                onClick={() => onPlayMessage(message.date)}
                            />
                        )}
                        <IntentPopOver
                            className="intentPopOver"
                            title="Ajouter comme expression"
                            trigger="click"
                            visible={isExpressionPopOverVisible}
                            onVisibleChange={visible =>
                                setIsExpressionPopOverVisible(visible)
                            }
                            content={
                                <ContainerPopOver>
                                    <IntentSelector
                                        message={message.text}
                                        intents={intents}
                                    />
                                </ContainerPopOver>
                            }
                        >
                            <Button
                                icon={<DatabaseOutlined />}
                                value="small"
                                shape="circle"
                            />
                        </IntentPopOver>
                    </Space>
                </ToolBoxArea>
            ) : null}
        </Container>
    )

    return renderContent()
}

export default Message
